export default [
  {
    addAddress: "Tilføj ny adresse",
    addNewCard: "Tilføj nyt kort",
    addresses: "Adresser",
    change: "Rediger",
    change_password: "Skift adgangskode",
    deleteAddress: "Vil du slette adressen",
    deletePaymentMethod: "Vil du slette kortet",
    editAddress: "Rediger adresse",
    email: "Email",
    noticeCard:
      "Du kan bruge dit debit- eller kreditkort til at bestille med %{appName}. Der bliver ikke trukket penge fra dit kort, kun når du bestiller.",
    orderHistory: "Ordre historik",
    password: "Adgangskode",
    paymentMethods: "Betalingsmetoder",
    personalInfo: "Personlig info",
    phoneNumber: "Telefonnummer",
    profile: "Profil",
    searchByReference: "Søg efter reference",
    setAsDefault: "Vælg som standard",
    settings: "Indstillinger",
    share: "Del",
    credits: "Kredit",
    campaignName: "Campaign name",
    campaignOffer: "Campaign offer",
    shareComp: {
      subTitle: "Del din kode med venner og familie",
      title: "Hvordan virker rabat kode?",
      codeTitle: "Din personlige kode",
      dividerText: "Del din rabat kode",
      list1:
        "Kopier din personlige rabat kode, og del den med dine venner og familie",
      list2:
        "Du tjener {value} kr i app credits hver gang nogle bruger dine kode til bestilling.",
    },
    creditComp: {
      title: "Rabat kode",
      description:
        "Hvis du har købt et værdibevis / rabat kode, så skal den bruges ved betaling.",
      inputText: "Indtast rabat kode",
      buttonText: "Godkend",
      success:
        "Tillykke der er tilføjet {amount} Dkk. app credits til din konto",
    },
    creditDesc: "You can use credits to pay your order.",
    smsCampaign: "Modtag kampagner på sms",
    emailCampaign: "Modtag kampagner på email",
    deleteAccount: "Slet konto",
    deleteAccountDesc:
      "Er du sikker på du vil slette din konto? (Denne handling kan ikke fortrydes)",
  },
];
